var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_8018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 80C26.9391 80 25.9217 79.5786 25.1716 78.8284C24.4214 78.0783 24 77.0609 24 76V64H8C5.87827 64 3.84344 63.1571 2.34315 61.6569C0.842854 60.1566 0 58.1217 0 56V8C0 5.87827 0.842854 3.84344 2.34315 2.34315C3.84344 0.842854 5.87827 0 8 0H72C74.1217 0 76.1566 0.842854 77.6569 2.34315C79.1572 3.84344 80 5.87827 80 8V56C80 58.1217 79.1572 60.1566 77.6569 61.6569C76.1566 63.1571 74.1217 64 72 64H47.6L32.8 78.84C32 79.6 31 80 30 80H28Z",
    fill: "url(#paint0_linear_45_8018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 20H46V14C46 11.8 44.2 10 42 10H38C35.8 10 34 11.8 34 14V20H24C21.8 20 20 21.8 20 24V46C20 48.2 21.8 50 24 50H56C58.2 50 60 48.2 60 46V24C60 21.8 58.2 20 56 20ZM38 14H42V24H38V14ZM38 38H34V42H30V38H26V34H30V30H34V34H38V38ZM42 35V32H54V35H42ZM42 41V38H50V41H42Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_8018",
    x1: 71.25,
    y1: -11.25,
    x2: 20.625,
    y2: 87.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFA73F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_8018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorBadge);
export default __webpack_public_path__ + "static/media/doctor-badge.7eea610242a8bdbdb0c7b9c526a41310.svg";
export { ForwardRef as ReactComponent };